// Microsoft Clarity session recording (privacy policy: Cookies, Analytics and Session Recording).
// It runs only while the visitor's Analytics consent is affirmative and they have not opted out of the
// sale or sharing of their data (Do Not Sell or Share, Global Privacy Control): Microsoft may reuse
// Clarity data for its own purposes. Where consent comes first (EEA, UK, Switzerland, California) Analytics
// is not affirmative until Accept. Opting out stops recording on that page at once. What shoppers type is
// masked with data-clarity-mask (personalization.js maskRecording), never sent.

export function sessionRecordingAllowed(snapshot) {
  return snapshot?.status === 'ready' && snapshot.analyticsAffirmative === true && snapshot.saleOfDataAllowed === true;
}

export function controlSessionRecording({ projectId, privacy, host = globalThis.window, page = globalThis.document }) {
  if (typeof projectId !== 'string' || !/^[a-z0-9]{6,20}$/i.test(projectId) || typeof privacy?.subscribe !== 'function') return () => undefined;
  let state = 'idle';
  // Clarity is never used for advertising, so its ad signal is always denied.
  const signal = granted => host.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: granted ? 'granted' : 'denied' });
  return privacy.subscribe(snapshot => {
    const allowed = sessionRecordingAllowed(snapshot);
    if (allowed && state === 'idle') {
      state = 'running';
      host.clarity = host.clarity || function clarity() { (host.clarity.q = host.clarity.q || []).push(arguments); };
      signal(true);
      const script = page.createElement('script');
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
      page.head.appendChild(script);
    } else if (!allowed && state === 'running') {
      // Once stopped, recording stays off for the rest of this page, even if consent is granted again.
      state = 'stopped';
      signal(false);
      host.clarity('stop');
    }
  });
}

function install() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const projectId = document.querySelector('script[data-clarity-project]')?.dataset.clarityProject;
  const start = () => controlSessionRecording({ projectId, privacy: window.FoldedLabelCustomerPrivacy });
  if (window.FoldedLabelCustomerPrivacy) start();
  else document.addEventListener('foldedlabel:customer-privacy-ready', start, { once: true });
}

install();
